import _ from 'lodash'
import createModel from 'utils/model'
import {formatTableParams} from 'utils/index'
import {getAutoMassSendingList, getDetailTableList} from './service'

function reformatParams(params) {
    const newParams = {...params}
    if (params?.start_time) {
        newParams.create_time_from = newParams.start_time
        newParams.create_time_to = newParams.end_time
        delete newParams.start_time
        delete newParams.end_time
    }
    return newParams
}

export default createModel({
    namespace: 'auto_mass_sending',
    state: {
        tableData: {},
        detailTable: {},
    },

    effects: {
        *getTableList(x, {select, put, call}) {
            const {tableData} = yield select(({auto_mass_sending}) => auto_mass_sending)
            const params = formatTableParams(tableData)
            const newParams = reformatParams(params)
            const res = yield call(getAutoMassSendingList, newParams)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                    draft.tableData.pagination.total = _.get(res, 'pagination.rows_found', 0)
                },
            })
        },

        *getDetailTableList(x, {select, put, call}) {
            const {detailTable} = yield select(({autoRecord}) => autoRecord)
            const params = formatTableParams(detailTable)
            const res = yield call(getDetailTableList, params)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.detailTable.dataSource = res.data
                    draft.detailTable.pagination.total = _.get(res, 'pagination.rows_found', 0)
                },
            })
        },
    },
})
